export default "__VITE_ASSET__FYAYJRzS__"